import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=7fe87be6&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"
import style0 from "./configuration.vue?vue&type=style&index=0&id=7fe87be6&lang=scss&scoped=true"
import style1 from "./configuration.vue?vue&type=style&index=1&id=7fe87be6&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe87be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7fe87be6')) {
      api.createRecord('7fe87be6', component.options)
    } else {
      api.reload('7fe87be6', component.options)
    }
    module.hot.accept("./configuration.vue?vue&type=template&id=7fe87be6&scoped=true", function () {
      api.rerender('7fe87be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/parameter/configuration.vue"
export default component.exports